export default [
    {
        path: '/faqCategories',
        name: 'faqCategories',
        component: () => import ('./pages/Index')
    },
]